<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: {{$t('AddNew')}} Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="color: white;">{{ Object.entries(this.data).length === 0 ? 'اضافه اشتراكات سنويه جديده' : 'تعديل الاشتراكات السنويه' }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">
        <!-- NAME -->
        <label style="font-weight: bold;color: white;">اسم الباقه</label>
        <vs-input style="color: white;" v-model="Name" class="mt-5 w-full" name="Name"/>
        <span style="color: white;" class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>

      <div class="p-6">
        <!-- NAME -->
        <label style="font-weight: bold;color: white;">السعر</label>
        <vs-input  style="color: white;" v-model="Price" class="mt-5 w-full" name="Price"/>
        <span  class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
      </div>
      <div class="p-6">
        <!-- NAME -->
        <label style="font-weight: bold;color: white;">عدد شهور الباقه </label>
        <vs-input style="color: white;" v-model="NomperOfMonths" class="mt-5 w-full" name="NomperOfMonths"/>
        <span class="text-danger text-sm" v-show="errors.has('NomperOfMonths')">{{ errors.first('NomperOfMonths') }}</span>
      </div>
      <div class="flex flex-wrap items-center p-6" >
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid" style="background-color: aliceblue; color: black; font-weight: bold;" color="info">{{$t("Save")}}</vs-button>
        
      </div>
      

    </VuePerfectScrollbar>


  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },

  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { Id, Name,Price,NomperOfMonths} = JSON.parse(
          JSON.stringify(this.data)
        );
        this.Id = Id;
        this.Name = Name;
        this.Price=Price;
        this.NomperOfMonths = NomperOfMonths;
        

      }

    }
  },
  data() {
    return {
     // countries: [],
      Id: 0,
      Name: "",
      NomperOfMonths: 0,
      Price:0,
      
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");

        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.Name && this.NomperOfMonths && this.Price;
    }
  },
  methods: {
    initValues() {
      if (this.data.Id) return;
      this.Id = 0;
      this.Name = "";
      this.NomperOfMonths = "";
      this.Price=0;
     
    },
    submitData() {
      debugger;
      this.$validator.validateAll().then(result => {
        if (result) {
          const PackageDTO = {
            Id: this.Id,
            Name: this.Name,
            NomperOfMonths: this.NomperOfMonths,
            Price:this.Price,
           
          };

          if (this.Id !== null && this.Id > 0) {
            debugger;
            this.$store.dispatch("SubscriptionPeriodList/updateItem", PackageDTO).then(() => {
              debugger;
                this.$store.dispatch("PackageList/fetchDataListItems");
                window.showSuccess();
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            delete PackageDTO.Id;
            PackageDTO.popularity = 0;
            this.$store
              .dispatch("SubscriptionPeriodList/addItem", PackageDTO)
              .then(() => {
                this.$store.dispatch("SubscriptionPeriodList/fetchDataListItems");
                window.showSuccess();
              })
              .catch((err) => {
                console.error(err);
              });
          }

          this.$emit("closeSidebar");
          this.initValues();
        }
      });
    },
  },  
  created() {},
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>